import axios from 'axios';

const wbsBookingsApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default wbsBookingsApi;
